import { action, observable } from 'mobx';
import { version } from 'mobx-sync';

@version(1)
export class AdminAuthStore {
  @observable authenticated: boolean;
  authToken: string;

  constructor() {
    this.clear();
  }

  @action
  authenticate(authToken: string): void {
    this.authToken = authToken;
    this.authenticated = true;
  }

  @action
  clear(): void {
    this.authenticated = false;
    this.authToken = null;
  }
}



// WEBPACK FOOTER //
// ./store/admin-auth-store.ts